var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { id: "snb" } }, [
    _vm.myPageList.length
      ? _c("section", { staticClass: "snb_sec mypage_wrap" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.MYPAGE")))]),
          _vm._v(" "),
          _c("div", { staticClass: "list" }, [
            _c(
              "ul",
              { staticClass: "list_mymenu" },
              _vm._l(_vm.myPageList, function(menu) {
                return _c("li", { key: menu.menuId }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.handleMoveMenu($event, menu)
                        }
                      }
                    },
                    [_vm._v(_vm._s(menu.menuNm))]
                  )
                ])
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.treeObj.length
      ? _c("section", { staticClass: "snb_sec mymenu_wrap" }, [
          _c(
            "dl",
            {
              staticClass: "tree_wrap",
              staticStyle: { "border-top": "0px solid #aaa" }
            },
            [
              _c("h2", [_vm._v("Admin")]),
              _vm._v(" "),
              _c("dd", [
                _c("article", { staticClass: "tree_group" }, [
                  _c(
                    "ul",
                    { staticClass: "tree_list" },
                    _vm._l(_vm.treeObj, function(menu1) {
                      return _c("li", { key: "tree" + menu1.menuId }, [
                        menu1._children
                          ? _c(
                              "a",
                              {
                                staticClass: "ico_tree",
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function($event) {
                                    return _vm.treeClick($event, menu1.menuId)
                                  }
                                }
                              },
                              [_c("span", { staticClass: "sr_only" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                return _vm.handleMoveMenu(
                                  $event,
                                  menu1,
                                  menu1._children
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(menu1.menuNm))]
                        ),
                        _vm._v(" "),
                        menu1._children
                          ? _c(
                              "ul",
                              { staticClass: "tree_sub_list" },
                              _vm._l(menu1._children, function(menu2) {
                                return _c(
                                  "li",
                                  { key: "tree" + menu2.menuId },
                                  [
                                    menu2._children
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "ico_tree",
                                            attrs: { href: "javascript:" },
                                            on: {
                                              click: function($event) {
                                                return _vm.treeClick(
                                                  $event,
                                                  menu2.menuId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticClass: "sr_only"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.handleMoveMenu(
                                              $event,
                                              menu2,
                                              menu2._children
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(menu2.menuNm))]
                                    ),
                                    _vm._v(" "),
                                    menu2._children
                                      ? _c(
                                          "ul",
                                          { staticClass: "tree_sub_list" },
                                          _vm._l(menu2._children, function(
                                            menu3
                                          ) {
                                            return _c(
                                              "li",
                                              { key: "tree" + menu3.menuId },
                                              [
                                                menu3._children
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass: "ico_tree",
                                                        attrs: {
                                                          href: "javascript:"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.treeClick(
                                                              $event,
                                                              menu3.menuId
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass: "sr_only"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleMoveMenu(
                                                          $event,
                                                          menu3,
                                                          menu3._children
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(menu3.menuNm))]
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      : _vm._e()
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35d78d5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d78d5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/main/AdminSnb.vue
// module id = 6vyP
// module chunks = 0